var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoresult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 132,
    viewBox: "0 0 137 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 100C96.2998 100 116 80.3386 116 56C116 31.6614 96.213 12 72 12C47.7002 12 28 31.6614 28 56C28 80.3386 47.7002 100 72 100Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.433 42.2493C123.407 42.2493 125.007 40.6492 125.007 38.6754C125.007 36.7016 123.407 35.1016 121.433 35.1016C119.459 35.1016 117.859 36.7016 117.859 38.6754C117.859 40.6492 119.459 42.2493 121.433 42.2493Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.659 28.3032C128.007 28.3032 129.1 27.2105 129.1 25.8626C129.1 24.5146 128.007 23.4219 126.659 23.4219C125.311 23.4219 124.219 24.5146 124.219 25.8626C124.219 27.2105 125.311 28.3032 126.659 28.3032Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4329 27.2564C30.7808 27.2564 31.8735 26.1636 31.8735 24.8157C31.8735 23.4677 30.7808 22.375 29.4329 22.375C28.0849 22.375 26.9922 23.4677 26.9922 24.8157C26.9922 26.1636 28.0849 27.2564 29.4329 27.2564Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5327 74.3232C17.036 74.3232 19.0654 72.2938 19.0654 69.7905C19.0654 67.2872 17.036 65.2578 14.5327 65.2578C12.0294 65.2578 10 67.2872 10 69.7905C10 72.2938 12.0294 74.3232 14.5327 74.3232Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_43049_126250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.603 98.0998H33.6689C32.2286 98.0998 31.0469 96.9181 31.0469 95.4778V77.4189C31.0469 75.9786 32.2286 74.7969 33.6689 74.7969H107.603C109.043 74.7969 110.225 75.9786 110.225 77.4189V95.4778C110.225 96.9181 109.043 98.0998 107.603 98.0998Z",
    fill: "url(#paint0_linear_43049_126250)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3355 83.5468H54.1583C53.272 83.5468 52.5703 83.0083 52.5703 82.3281C52.5703 81.6479 53.272 81.1094 54.1583 81.1094H95.3355C96.2218 81.1094 96.9235 81.6479 96.9235 82.3281C96.9235 83.0083 96.2218 83.5468 95.3355 83.5468Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5634 90.9686H54.1583C53.272 90.9686 52.5703 90.4301 52.5703 89.7499C52.5703 89.0697 53.272 88.5312 54.1583 88.5312H80.5634C81.4497 88.5312 82.1514 89.0697 82.1514 89.7499C82.1514 90.4301 81.4497 90.9686 80.5634 90.9686Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9798 93.0065C45.6103 93.0065 48.5534 90.0634 48.5534 86.4329C48.5534 82.8025 45.6103 79.8594 41.9798 79.8594C38.3493 79.8594 35.4062 82.8025 35.4062 86.4329C35.4062 90.0634 38.3493 93.0065 41.9798 93.0065Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5821 84.932L40.4459 89.0312L39.3906 87.9664L43.5268 83.8672L44.5821 84.932Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4459 83.8672L44.5821 87.9664L43.5268 89.0312L39.3906 84.932L40.4459 83.8672Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_43049_126250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.088 38.6154H36.1533C34.713 38.6154 33.5312 37.4337 33.5312 35.9934V17.9345C33.5312 16.4943 34.713 15.3125 36.1533 15.3125H110.088C111.528 15.3125 112.71 16.4943 112.71 17.9345V35.9934C112.71 37.4337 111.528 38.6154 110.088 38.6154Z",
    fill: "url(#paint1_linear_43049_126250)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8198 24.0624H56.6427C55.7564 24.0624 55.0547 23.5239 55.0547 22.8437C55.0547 22.1635 55.7564 21.625 56.6427 21.625H97.8198C98.7062 21.625 99.4078 22.1635 99.4078 22.8437C99.4078 23.5239 98.7062 24.0624 97.8198 24.0624Z",
    fill: "#D6DCE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0478 31.4843H56.6427C55.7564 31.4843 55.0547 30.9458 55.0547 30.2656C55.0547 29.5854 55.7564 29.0469 56.6427 29.0469H83.0478C83.9341 29.0469 84.6358 29.5854 84.6358 30.2656C84.6358 30.9458 83.9341 31.4843 83.0478 31.4843Z",
    fill: "#D6DCE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4642 33.5221C48.0947 33.5221 51.0378 30.5791 51.0378 26.9486C51.0378 23.3181 48.0947 20.375 44.4642 20.375C40.8337 20.375 37.8906 23.3181 37.8906 26.9486C37.8906 30.5791 40.8337 33.5221 44.4642 33.5221Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9987 25.8022L43.3325 30.4684L40.7344 27.8703L41.7944 26.8103L43.3325 28.3483L46.9386 24.7422L47.9987 25.8022Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_43049_126250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7416 68.217H24.7705C23.3302 68.217 22.1484 67.0352 22.1484 65.595V47.5361C22.1484 46.0958 23.3302 44.9141 24.7705 44.9141H98.7047C100.145 44.9141 101.327 46.0958 101.327 47.5361V65.595C101.364 67.0722 100.182 68.217 98.7416 68.217Z",
    fill: "url(#paint2_linear_43049_126250)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1126 63.155C36.7431 63.155 39.6862 60.2119 39.6862 56.5814C39.6862 52.9509 36.7431 50.0078 33.1126 50.0078C29.4822 50.0078 26.5391 52.9509 26.5391 56.5814C26.5391 60.2119 29.4822 63.155 33.1126 63.155Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7487 55.0444L32.0825 59.7106L29.4844 57.1125L30.5444 56.0525L32.0825 57.5905L35.6886 53.9844L36.7487 55.0444Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4839 53.6718H45.3067C44.4204 53.6718 43.7188 53.1333 43.7188 52.4531C43.7188 51.7729 44.4204 51.2344 45.3067 51.2344H86.4839C87.3702 51.2344 88.0719 51.7729 88.0719 52.4531C88.0719 53.1333 87.3333 53.6718 86.4839 53.6718Z",
    fill: "#D6DCE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7118 61.1249H45.3067C44.4204 61.1249 43.7188 60.5864 43.7188 59.9062C43.7188 59.226 44.4204 58.6875 45.3067 58.6875H71.7118C72.5982 58.6875 73.2998 59.226 73.2998 59.9062C73.2629 60.5864 72.5612 61.1249 71.7118 61.1249Z",
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_43049_126250",
    x: 9.04688,
    y: 63.7969,
    width: 123.178,
    height: 67.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43049_126250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43049_126250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_43049_126250",
    x: 11.5312,
    y: 4.3125,
    width: 123.178,
    height: 67.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43049_126250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43049_126250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_43049_126250",
    x: 0.148438,
    y: 33.9141,
    width: 123.179,
    height: 67.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43049_126250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43049_126250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43049_126250",
    x1: 70.6102,
    y1: 74.2579,
    x2: 70.6102,
    y2: 98.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43049_126250",
    x1: 73.0946,
    y1: 14.7735,
    x2: 73.0946,
    y2: 38.8667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43049_126250",
    x1: 61.7122,
    y1: 44.375,
    x2: 61.7122,
    y2: 68.4682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresult);
export default __webpack_public_path__ + "static/media/noresult.52fcb5f5a869bb01e42a1df5c8c29514.svg";
export { ForwardRef as ReactComponent };